var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "#7029a3",
    stroke: "#000",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16 2.9166c3.1498 0 5.4873 8.6e-4 7.2822 0.24218 1.7877 0.24036 2.9998 0.71559 3.9219 1.6377 0.922 0.92209 1.3974 2.1342 1.6377 3.9219 0.2413 1.7948 0.2422 4.1318 0.2422 7.2812 0 3.1498-9e-4 5.4874-0.2422 7.2823-0.2403 1.7876-0.7156 2.9998-1.6377 3.9218-0.9221 0.9222-2.1342 1.3974-3.9219 1.6377-1.7949 0.2414-4.1324 0.2422-7.2822 0.2422-3.1494 0-5.4864-9e-4 -7.2812-0.2422-1.7876-0.2403-2.9998-0.7156-3.9219-1.6377-0.9221-0.922-1.3973-2.1342-1.6377-3.9218-0.24132-1.7949-0.24219-4.1325-0.24219-7.2823 0-3.1494 9.1e-4 -5.4864 0.24219-7.2812 0.24035-1.7877 0.71557-2.9998 1.6377-3.9219 0.9221-0.92213 2.1342-1.3973 3.9219-1.6377 1.7948-0.24128 4.1317-0.24218 7.2812-0.24218zm5.5508 8.8662c-0.4882-0.4881-1.2794-0.4881-1.7676 0l-5.7832 5.7823-1.7822-1.7823c-0.4881-0.4881-1.2794-0.4879-1.7676 0-0.48814 0.4882-0.48814 1.2794 0 1.7676l2.666 2.667c0.4881 0.4881 1.2794 0.4879 1.7676 0l6.667-6.667c0.4882-0.4881 0.4882-1.2794 0-1.7676z",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckbox);
export default __webpack_public_path__ + "static/media/icon_checkbox.7a45551f69a73680d981cd567fca57b8.svg";
export { ForwardRef as ReactComponent };